import { BigJunctureData, ExpandedStation, Station, StationStatus, StationType } from 'pages/Map/types';
import { BaseStation } from '../BaseStation';
import { DecisionStation } from '../Decision/DecisionStation';
import { Path } from '../../../Path';
import { X_SCALE_VALUE, Y_STEP_UP } from 'constants/map';

export class BigJunctureStation extends BaseStation {
    type: StationType.BigJuncture;
    stations: DecisionStation[];

    constructor(station: BigJunctureData) {
        const { type, stations, ...baseStationData } = station;
        super(baseStationData);

        this.type = type;
        this.stations = stations.map(subStation => new DecisionStation({ ...subStation, parentStation: this }));
    }

    getStations() {
        return this.stations;
    }

    getType() {
        return this.type;
    }

    getStationStatus(activeStation: Station | undefined, paths: Path[], selectedStation?: Station) {
        const isActive = this.stations.some(station => {
            return station.getId() === activeStation?.getId();
        });
        if (isActive) {
            return StationStatus.ACTIVE_STATION;
        }

        return super.getStationStatus(activeStation, paths, selectedStation);
    }

    isExpanded(station: ExpandedStation) {
        return this.id === station?.getId();
    }

    /**
     * Big junctures will exapand in both directions(left and right) by half
     */
    getWidthOnLeft() {
        return (X_SCALE_VALUE * this.stations.length) / 2;
    }

    getWidthOnRight() {
        return this.getWidthOnLeft() + X_SCALE_VALUE;
    }

    getWidth() {
        return this.getWidthOnLeft() + this.getWidthOnRight();
    }

    /**
     * In most zoomed out view we need additional space below when big juncture expands
     */
    getHeight() {
        return Y_STEP_UP;
    }
}
